// extracted by mini-css-extract-plugin
module.exports = {"TeamMemberHero":"styles_TeamMemberHero__qtLZb","img":"styles_img__p1z_i","bg_1":"styles_bg_1__d_Ft5","height":"styles_height__0StCd"};